import { Builder } from '@builder.io/react';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';
import { SchemaRating } from '../../specials';

Builder.registerComponent(SchemaRating, {
  name: BUILDER_DIVIDER_NAMES.RatingsDivider,
});
